import request from '@/utils/request'

const prefix = '/django_rest/job-posting'
const clientAdminPrefix = '/django_rest/client-admin/job-posting'

export default {
  getPostingFieldList (params) {
    return request.get(`${prefix}/posting-field/`, { params })
  },
  getPostingFieldDetail (channelId, fieldType) {
    return request.get(`${prefix}/posting-field/${channelId}/${fieldType}/`)
  },
  savePostingField (channelId, fieldType, fieldInfo) {
    return request.post(`${prefix}/posting-field/${channelId}/${fieldType}/`, fieldInfo)
  },
  getPostingFieldOptions (fieldTypeId, params) {
    return request.get(`${prefix}/field-type/option/${fieldTypeId}/`, { params })
  },
  searchPostingFieldOptions (params) {
    return request.get(`${prefix}/field-type/option/`, { params })
  },
  getCustomFieldMatchedPostingField (params) {
    return request.post(`${prefix}/posting-field-match/`, params)
  },
  getJobPostingTaskList (params) {
    return request.get(`${clientAdminPrefix}/`, { params })
  },
  updateJobPostingTaskStatus (params) {
    return request.put(`${clientAdminPrefix}/`, params)
  },
  checkJobPostingChannel (params) {
    return request.get(`${prefix}/channel/check/`, { params })
  }
}
